// extracted by mini-css-extract-plugin
export default {"input":"edit-input_input__XhhX0","label":"edit-input_label__3U13D"};